import React, {Component} from 'react';
import {connect} from 'react-redux';
import history from '../../history';
import { observer } from "mobx-react";

class UrlPusher extends Component {
  componentDidMount() {
    this._ref.addEventListener("click", (e) => {
      if(e.target.tagName == 'A') {
        const url=e.target.attributes.href.nodeValue;
        const homeUrl=window.location.protocol+'//'+window.location.hostname+(window.location.port?`:${window.location.port}`:"");
        if(url.indexOf(homeUrl) === 0 || (url.indexOf('/') === 0 && url.indexOf('//')!==0)) {
          e.preventDefault();
          e.stopPropagation();
          history.push(url.replace(homeUrl,''));
        }
      }
    });
  }

  render() {
    return (
      <div ref={(ref)=>{ this._ref=ref; }}>
        {this.props.children}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default observer(UrlPusher);